import { render, staticRenderFns } from "./DxCostsForm.vue?vue&type=template&id=14dd4172&"
import script from "./DxCostsForm.vue?vue&type=script&lang=js&"
export * from "./DxCostsForm.vue?vue&type=script&lang=js&"
import style0 from "./DxCostsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports